import { render, staticRenderFns } from "./EmailsDashboard.vue?vue&type=template&id=0ee33147&scoped=true"
import script from "./EmailsDashboard.vue?vue&type=script&lang=js"
export * from "./EmailsDashboard.vue?vue&type=script&lang=js"
import style0 from "./EmailsDashboard.vue?vue&type=style&index=0&id=0ee33147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee33147",
  null
  
)

export default component.exports